import moment from "moment"
import nacionalidade from "@/constants/repositorio/nacionalidade"

export function filterDate (value) {
  if (value) {
    return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
  }
}

export function filterDateDefault (value) {
  if (value) {
    return moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD')
  }
}

export function filterDateHour (value) {
  if (value) {
    return new moment(value).format('DD/MM/YYYY HH:mm')
  } else {
    return ''
  }
}

export function filterEndereco (value, pais = false) {
  if (!value) return  'Endereço Não Cadastrado'

  if (value.enderecos) {
    const { enderecos } = value

    return filterEndereco(enderecos[0])
  }

  if (value.endereco && Object.keys(value.endereco).length) {

    if (value.endereco.logradouro && value.endereco.exterior) {
      return `${value.endereco.logradouro || 'Não informado'}${ (value.endereco.codigo_pais && pais) && ' - ' + getPaisById(value.endereco.codigo_pais).nome }`
    }

    if (value.endereco.cep && value.endereco.logradouro && value.endereco.bairro && value.endereco.uf) {
      return `${value.endereco.logradouro}, ${value.endereco.numero || 'S/N'} - ${value.endereco.bairro || 'Não informado'}/${value.endereco.cidade || 'Não informado'} - ${value.endereco.uf || 'Não informado'}, ${value.endereco.cep || 'Não informado'}`
    }

    if (value.endereco.logradouro && !value.endereco.exterior) {
      return `${value.endereco.logradouro}, ${value.endereco.numero || 'S/N'} - ${value.endereco.bairro || 'Não informado'}/${value.endereco.cidade || 'Não informado'}`
    }

    if (value.endereco.uf && value.endereco.cidade) {
      return `${value.endereco.cidade} - ${value.endereco.uf}`
    }
  }

  if (value.logradouro && value.exterior) {
    return `${value.logradouro || 'Não informado'}${ (value.codigo_pais && !pais) ? ' - ' + getPaisById(value.codigo_pais) : '' }`
  }

  if (value.cep && value.logradouro && value.bairro && value.uf) {
    return `${value.logradouro}, ${value.numero || 'S/N'} - ${value.bairro || 'Não informado'}/${value.cidade || 'Não informado'} - ${value.uf || 'Não informado'}, ${value.cep || 'Não informado'}`
  }

  if (value.logradouro && !value.exterior) {
    return `${value.logradouro}, ${value.numero || 'S/N'} - ${value.bairro || 'Não informado'}/${value.cidade || 'Não informado'}`
  }

  if (value.uf && value.cidade) {
    return `${value.cidade} - ${value.uf}`
  }

  return  'Endereço Não Cadastrado'
}

/**
 * Recebe em centavos e retorna pronta para exibição R$00,00
 */
export function moneyToString (value) {
  return (value / 100).toLocaleString("pt-BR", { style: "currency", currency: "brl" })
}

export function getPaisById (codigo) {
  return nacionalidade.find(pais => pais.codigo == codigo).nome
}

/**
 * Recebe uma string com um número formatado com mascara
 * e devolve sem mascara.
 *
 * EX.: recebe 000.000.000-00 devolve 00000000000
 */
export function filterMaskedNumber (value) {
  if (value) {
    return value.replace(/\.|-|\/|_|\(|\)/g, '')
  }
}

export function maskCPF (value) {
  if (value) {
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
  } else {
    return 'Não informado'
  }
}

export function maskCNPJ (value) {
  if (value) {
    const cleanedValue = value.replace(/\D/g, '')
    return cleanedValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
  } else {
    return 'Não informado'
  }
}

export function filterHour (value) {
  if (value) {
    return moment(value, 'H:mm').format('H:mm')
  } else {
    return 'Não informado'
  }
}

export function firstCapitalize (value) {
  if (value) {
    let texts = value.split(' ')

    texts = texts.map(item => item && item[0].toUpperCase() + item.substr(1).toLowerCase())

    return texts.join(' ')
  }
}

export function maskDnv (dnv) {
  if (dnv == "Não informado" || dnv.length !== 11) {
    return dnv
  }

  return dnv.substring(0, 2) + '-' + dnv.substring(2, 10) + '-' + dnv.substring(10, 11)
}

export function filterTelefone (number) {
  if (!number) return null

  const newNumber = number.replace(/\.|-|\/|\(|\)|[ ]/g, '')

  if (newNumber.length === 10 || newNumber.length === 11) return newNumber
}
